import React from 'react';
import ContactForm from './ContactForm';

const ContactSection = () => {
    return (
        <section className="contact" id="contact">
            <div className="container">
                <div className="text_center mbBig">
                    <h2 className="headingSecondary">Get in touch</h2>
                </div>

                <ContactForm></ContactForm>
            </div> {/* Container */}
        </section> // Contact
    );
};

export default ContactSection;